import React, { Component } from 'react';
import {Link} from "react-router-dom";
import Container from '@material-ui/core/Container';
import moment from "moment";

import PushHistory from '../../../utils/PushHistory';
import { getSystemSettings, getSelectedPromocode, getDestination, getFormData, setSeason, getSeason } from '../../../utils/SettingsRetriever';
import { store } from '../../../store/configureStore';

import IntlMessage from '../../../LocaleEngine';
import LocaleAsString from '../../../LocaleEngine/LocaleAsString';

import SpotlioIcon from '../../Icon';

export default class TabGenerator extends Component{
    constructor(props){
        super(props);
        this.state = {
            selectedTab: -1,
            cart: this.getCurrentStateFromStore()
        }
    }

    componentDidMount(){
        document.addEventListener("destinationUpdate", this.handleNewDestination, false);
        document.addEventListener("changeSeason", this.changeSeason, false);
        this.cartState();
        this.unsubscribeStore = store.subscribe(this.updateStateFromStore);
    }

    componentWillUnmount(){
        document.removeEventListener("destinationUpdate", this.handleNewDestination, false);
        document.removeEventListener("changeSeason", this.changeSeason, false);
        this.unsubscribeStore();
    }

    changeSeason = () => {
        let system = getSystemSettings();
        let season = getSeason();
        // we make sure all the variables we need exists
        if (system && system.seasonality && system.seasonality.enabled && season){
            document.getElementsByClassName("main-application")[0].style.backgroundImage = `url(${season.background})`;
            this.forceUpdate();
        }
    }

    getCurrentStateFromStore = () => {
        return {
          cart: store.getState().cart.cart.response
        }
    }

    updateStateFromStore = () => {
        const currentStoreState = this.getCurrentStateFromStore();
        const currentState = this.state.cart;

        if (currentState.cart !== currentStoreState.cart) {
          this.setState({...this.state, cart: currentStoreState}, () => {
            this.cartState();
          });
        }
    }

    cartState = () => {
        let state = this.state;
        const storedCart = state.cart.cart;

        let cartBadge = 0;

        if(storedCart){
            if(storedCart.items){
                storedCart.items.forEach(group => {
                    group.items.forEach(item => {
                        let qty = 1;
                        if(item.Quantity){
                            qty = item.Quantity;
                        }
                        cartBadge += qty;
                    });
                });
            }
        }

        state.cart.badge = cartBadge;

        this.setState(state);
    }

    handleNewDestination = () => {
        this.forceUpdate();
    }

    renderLink = (parameters) => {
        const system = getSystemSettings();
        const linkContent = (
            <React.Fragment>
                {parameters.icon}
                <span className="label">{parameters.title}</span>
            </React.Fragment>
        )
        if (system.categories[parameters.index].code === "link") {
            const category = system.categories[parameters.index];
            const link = category.href[0];
            const target = category.config.linkTarget || "_blank";

            return (
                <a key={parameters.index} title={parameters.linkTitle} className={parameters.class + ' headerTab'} href={link} target={target}>
                    {linkContent}
                </a>)
        }else{
            // render link
            return (
            <Link key={parameters.index} to={parameters.path} title={parameters.title} className={parameters.class + ' headerTab'}>
                {linkContent}
            </Link>)
        }
    }

    handlePush = (path, idx) => {
        const system = getSystemSettings();
        if (system.categories[idx].code === "link") {
            const category = system.categories[idx];
            window.open(category.href[0], category.config.linkTarget || "_blank");
        } else {
            PushHistory(path);
            this.setState({selectedTab:idx})
        }
    }

    handleActionMobile = (urlPath, idx) => {
        this.handlePush(urlPath, idx);
        this.props.toggleMenu && this.props.toggleMenu();
    }

    checkDestination = (destinationsID, code) => {
        let hideCategory = true;
        let { multiDestination } = getSystemSettings();
        
        if (destinationsID){
            destinationsID.forEach(dest => {
                let destination = multiDestination.list.find(d => d.id === parseInt(dest))
                if (destination.config && destination.config.categories){
                    if (destination.config.categories.find(category => category.code === code)){
                        hideCategory = false;
                    }
                }
            })
        }

        return hideCategory;
    }

    checkSeasonality = (currentSeason, seasons, seasonality) => {
        // we assign the variable to a new one so we can manipulate it easily
        let activeSeason = currentSeason;
        if (activeSeason){
            // we search through the seasons of the section
            if (seasons && seasons.indexOf(activeSeason.name) >= 0){
                // if the section has the activeSeason, we don't hide it
                return false;
            } else {
                // if it doesn't have the season, we hide it
                return true;
            }
        } else {
            // if there's no season saved on LS, we get it through the current date
            let startDate = moment.utc(getFormData().lodging.arrivalDate).startOf("day");
            seasonality.list.forEach(season => {
                let seasonStart = moment.utc(season.start).startOf("day");
                let seasonEnd = moment.utc(season.end).startOf("day");

                if (startDate.isSameOrAfter(seasonStart) && startDate.isSameOrBefore(seasonEnd)){
                    activeSeason = season
                }
            })
            // if even after trying to find the season by the date we don't find any, we get the one marked as default
            if (!activeSeason){
                activeSeason = seasonality.list.find(season => season.isDefault === true);
            }

            setSeason(activeSeason);
            if (seasons && seasons.indexOf(activeSeason.name) >= 0){
                // if the section has the activeSeason, we don't hide it
                return false;
            } else {
                // if it doesn't have the season, we hide it
                return true;
            }
        }
    }

    render(){
        let items = [];
        let mobile = [];
        const system = getSystemSettings();
        const url = window.location.pathname;

        if (getSystemSettings().app && getSystemSettings().app.hideTopbarSelectedPromocode && getSelectedPromocode()) return null;
        if (system.b2b && system.b2b.showB2CTabs === false) return '';

        if(system.categories){
            system.categories.forEach((val, idx) => {
                let urlPath = val.href[0];
                if (val.href.indexOf(url) > -1 || (url === '/' && val.href.indexOf(system.app.defaultPage) >= 0)) {
                    if (this.state.selectedTab !== idx) {
                        this.setState({selectedTab:idx});
                    }
                }
                if (this.state.selectedTab === -1) {
                    val.href.forEach(jdx => {
                        if (url.substring(0, jdx.length) === jdx) {
                            if (this.state.selectedTab !== idx) {
                                this.setState({selectedTab:idx});
                            }
                        }
                    })
                }

                let icon = 'sp2-mountains';
                if(val.icon !== ''){
                    icon = val.icon;
                }

                let visible = true;
                if (getSystemSettings().multiDestination && getSystemSettings().multiDestination.enabled) {
                    if (!val.hide){
                        val.hide = this.checkDestination(getDestination(), val.code);
                    }
                }

                if (getSystemSettings().seasonality && getSystemSettings().seasonality.enabled){
                    if (!val.hide){
                        val.hide = this.checkSeasonality(getSeason(), val.config.seasons, getSystemSettings().seasonality)
                    }
                }

                if(val.hide){
                    visible = false;
                }

                if(this.props.upselling){
                    if(val.hide_upselling){
                        visible = false;
                    }
                }

                if(visible){
                    let code = val.code;
                    if(val.code === 'link') code = val.type;

                    let title = ""
                    if (val.title) title = LocaleAsString(val.title)
                    else title = <IntlMessage id={"skin.global.tabs." + code} />;

                    let iconElement = <SpotlioIcon icon={icon} />;
                    if(system.head.tabs){
                        if(system.head.tabs.icons && system.head.tabs.icons === 'hide'){
                            if(!this.props.upselling || this.props.isMobile){
                                iconElement = '';
                            }
                        }
                    }

                    let classElement = 'large';
                    if(system.head.tabs){
                        if(system.head.tabs.mode){
                            classElement = system.head.tabs.mode;
                        }
                        if(system.head.tabs.extraClass){
                            classElement += ' ' + system.head.tabs.extraClass;
                        }
                    }
                    items.push(
                        this.renderLink({
                            index: idx,
                            path: urlPath,
                            linkTitle: LocaleAsString("skin.global.tabs." + val.code),
                            class: classElement + ((idx === this.state.selectedTab) || (window.location.pathname.match('packages') && val.code === "packages") ? " active" : ""),
                            icon: iconElement,
                            title: title
                        })
                    )
                    mobile.push(
                        <div key={idx} onClick={() => (this.handleActionMobile(urlPath, idx))} className={"option " + ((idx === this.state.selectedTab) || (window.location.pathname.match('packages') && val.code === "packages") ? " active" : "")}>
                            {iconElement}
                            <span className="categoryText">{title}</span>
                        </div>
                    )
                }
            })
        } else {
            this.forceUpdate();
        }

        return (
            <Container className="tabsContainer" maxWidth="lg">
                {this.props.isMobile ?
                    mobile
                    :
                    items
                }
            </Container>
        )
    }
}


